import { memo, useId } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/icons/icon-24-logo-heygen-color-large.tsx
/**
* icon.24.logo.heygen.color.large
*
* ![](data:image/svg+xml;base64,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)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=26838-11587
*/
const Icon24LogoHeygenColorLarge = memo(function Icon24LogoHeygenColorLarge(props) {
	const id = useId();
	const ida = `${id}0`;
	const idb = `${id}1`;
	const idc = `${id}2`;
	const idd = `${id}3`;
	return /* @__PURE__ */ jsxs("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: [
			/* @__PURE__ */ jsx("path", {
				fill: `url(#${ida})`,
				d: "M10.5 10.382c1.764-.119 3.068 1.265 2.954 3.013-.014.206-.003.483-.003.695l-.002 2.353.003 2.29c0 .408.01.832-.01 1.235.008 1.045-1.5 1.1-2.166.709-.95-.558-1.905-1.383-2.811-2.033-.286-.253-1.011-.757-1.344-1.005l-2.816-2.102c-.606-.455-.924-.922-1.051-1.68-.167-.994.654-1.097 1.37-1.369l1.788-.676q.966-.36 1.928-.73c.615-.237 1.537-.63 2.16-.7"
			}),
			/* @__PURE__ */ jsx("path", {
				fill: `url(#${idb})`,
				d: "M16.382 9.646c.12-.014.308.001.426.027 1.188.255 2.37.544 3.556.804.92.201.645 1.396.383 2.011-.135.317-.394.668-.587.962l-.703 1.083-2.479 3.81c-.31.458-.559.866-.919 1.387-.319.461-1.31 1.209-1.642.281-.059-.166-.03-.936-.03-1.177l.003-2.154-.002-2.95c0-.516-.036-1.192.04-1.685.156-1.013.882-2.21 1.954-2.4"
			}),
			/* @__PURE__ */ jsx("path", {
				fill: `url(#${idc})`,
				d: "M10.134 3.276c.093-.01.225-.01.321-.014.31.256.778 1.294 1.003 1.683.495.858 1.151 1.732.606 2.734-.612 1.134-1.929 1.78-3.102 2.194-1.41.5-2.818 1.115-4.233 1.598-.2.091-1.373.577-1.5.457-.726-.68.47-1.873.907-2.389l1.599-1.888L7.75 5.27c.702-.827 1.276-1.699 2.383-1.993"
			}),
			/* @__PURE__ */ jsx("path", {
				fill: `url(#${idd})`,
				d: "M11.696 3.102c.681.08 1.638.84 2.21 1.242l2.515 1.76 2.525 1.768 1.067.746c.333.234.572.448.718.837a.8.8 0 0 1-.204.203c-.195.046-1.51-.318-1.824-.378-2.037-.394-3.966-.832-5.285-2.594-.7-.935-1.222-2.123-1.814-3.138-.106-.183-.075-.323.092-.446"
			}),
			/* @__PURE__ */ jsxs("defs", { children: [
				/* @__PURE__ */ jsxs("linearGradient", {
					id: ida,
					x1: "7.496",
					x2: "12.626",
					y1: "11.784",
					y2: "20.837",
					gradientUnits: "userSpaceOnUse",
					children: [
						/* @__PURE__ */ jsx("stop", {
							offset: ".2",
							stopColor: "#FDA1FF"
						}),
						/* @__PURE__ */ jsx("stop", {
							offset: ".3",
							stopColor: "#F3A4FF"
						}),
						/* @__PURE__ */ jsx("stop", {
							offset: ".48",
							stopColor: "#D9ADFF"
						}),
						/* @__PURE__ */ jsx("stop", {
							offset: ".71",
							stopColor: "#AFBCFF"
						}),
						/* @__PURE__ */ jsx("stop", {
							offset: ".83",
							stopColor: "#97C5FF"
						})
					]
				}),
				/* @__PURE__ */ jsxs("linearGradient", {
					id: idb,
					x1: "15.619",
					x2: "18.29",
					y1: "10.515",
					y2: "16.459",
					gradientUnits: "userSpaceOnUse",
					children: [/* @__PURE__ */ jsx("stop", { stopColor: "#3CE6AC" }), /* @__PURE__ */ jsx("stop", {
						offset: "1",
						stopColor: "#00E3FF"
					})]
				}),
				/* @__PURE__ */ jsxs("linearGradient", {
					id: idc,
					x1: "6.084",
					x2: "7.89",
					y1: "4.789",
					y2: "10.066",
					gradientUnits: "userSpaceOnUse",
					children: [/* @__PURE__ */ jsx("stop", { stopColor: "#00CDC3" }), /* @__PURE__ */ jsx("stop", {
						offset: "1",
						stopColor: "#4FDB5E"
					})]
				}),
				/* @__PURE__ */ jsxs("linearGradient", {
					id: idd,
					x1: "14.115",
					x2: "17.89",
					y1: "7.227",
					y2: "5.505",
					gradientUnits: "userSpaceOnUse",
					children: [/* @__PURE__ */ jsx("stop", {
						offset: ".04",
						stopColor: "#62C7FF"
					}), /* @__PURE__ */ jsx("stop", {
						offset: ".79",
						stopColor: "#D9B5FF"
					})]
				})
			] })
		]
	});
});
//#endregion
export { Icon24LogoHeygenColorLarge };

//# sourceMappingURL=icon-24-logo-heygen-color-large.js.map